import ExistsFilterParser from '../../../osd/filters/parsers/exists-filter-parser';
import { ElasticsearchFieldModel } from '../../../elasticsearch/elasticsearch-field';
import { ElasticsearchEnhancedFilterModel } from '../../../elasticsearch/elasticsearch-filter';
import { BaseExploreFilterParser } from './base';
/**
 * Elastic to ElasticsearchEnhancedFilterModel 'EXISTS' filter parser
 */
export class ExploreFilterExistsFilterParser extends BaseExploreFilterParser {
    constructor() {
        super(new ExistsFilterParser());
    }
    getFilter(elasticFilter, negate) {
        const metadata = this.getMetadata(elasticFilter, negate);
        if (!metadata)
            return null;
        const filter = new ElasticsearchEnhancedFilterModel();
        filter.type = 'EXIST';
        filter.negate = metadata.negate;
        filter.field = new ElasticsearchFieldModel();
        filter.field.name = metadata.key ?? '';
        return filter;
    }
    getElasticFilter(filter) {
        if (filter.type !== 'EXIST')
            return null;
        return { [this.baseFilterParser.elasticKey]: { field: filter.field?.name } };
    }
}
//# sourceMappingURL=exists.js.map